import { render, staticRenderFns } from "./VideoPlaceholder.vue?vue&type=template&id=05f30e3b&scoped=true"
import script from "./VideoPlaceholder.vue?vue&type=script&lang=js"
export * from "./VideoPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./VideoPlaceholder.vue?vue&type=style&index=0&id=05f30e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f30e3b",
  null
  
)

export default component.exports